<template>
  <div id="app">
    <div class="top lora py-1 px-3 h4">
      <img src="/content/reservation/img/intryga-logo.png" />
      Rezerwacja
    </div>
    <ReservationForm />
  </div>
</template>

<script>
import ReservationForm from '@/components/ReservationForm';

import 'bootstrap/dist/css/bootstrap.css';
import '@witkac/bootstrap4-components/public/css/font-awesome.min.css';

export default {
  name: 'app',
  components: { ReservationForm }
};
</script>

<style src="./styles/styles.scss" lang="scss" />

<style></style>
